import React from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import Importer from './pages/Importer';
import MapIncidents from './pages/MapIncidents';
import MapEngineering from './pages/MapEngineering';
import MapSurveillance from './pages/MapSurveillance';
import MapEducation from './pages/MapEducation';
import Login from './pages/Login';
import Register from './pages/Register';

import Redirect from './pages/Redirect';
import Dashboard from './pages/Dashboard';
import AddEngineering from './pages/AddEngineering';
import RegisterEngineering from './pages/RegisterEngineering';
import RegisterIncident from './pages/RegisterIncident';
import RegisterSurveillance from './pages/RegisterSurveillance';
import MyAccount from './pages/MyAccount';
import RegistersIncident from './pages/RegistersIncident';
import RegistersEngineering from './pages/RegistersEngineering';
import RegistersSurveillance from './pages/RegistersSurveillance';
import RegistersEducation from './pages/RegistersEducation';
import AddSurveillance from './pages/AddSurveillance';
import AddEducation from './pages/AddEducation';
import UpdateIncident from './pages/UpdateIncident';
import UpdateSurveilance from './pages/UpdateSurveilance';
import UpdateEngineering from './pages/UpdateEngineering';
import UpdateDuplicities from './pages/UpdateDuplicities';

import Duplicities from './pages/Duplicities';
import RegistersDuplicidades from './pages/RegistersDuplicidades';

import Review from './pages/Review';
import AddIncident from './pages/AddIncident';
import Export from './components/Export';
import Management from './pages/Management';
import History from './pages/History';
import ForgotPassword from './pages/ForgotPassword';
import EmailVerificationMessage from './pages/EmailVerificationMessage';
import UpdatePassword from './pages/updatePassword';
import BulletinAcess from './pages/BulletinAccess';
import BolletinViewer from './pages/BolletinViewer';
import MapIncidentsSAMU from './pages/MapIncidentsSAMU';
import RegistersIncidentSAMU from './pages/RegistersIncidentSAMU';
import RegisterIncidentSAMU from './pages/RegisterIncidentSAMU';
import RegisterEducation from './pages/RegisterEducation';
import UpdateIncidentSAMU from './pages/UpdateIncidentSAMU';
import UpdateEducation from './pages/UpdateEducation';
import AnalyzeDuplicity from './pages/AnalyzeDuplicity';
import ReviseLocation from './pages/ReviseLocation';
import UpdateInaccurate from './pages/UpdateInaccurate';

const Routes: React.FC = () => {
  const history = useHistory();

  return (
    <Switch>
      <Route exact path="/login" component={() => <Login />} />
      <Route exact path="/" component={() => <Redirect />} />
      <Route path="/registrar" component={Register} />
      <Route path="/recuperarsenha" component={ForgotPassword} />
      <Route path="/emailenviado" component={EmailVerificationMessage} />
      {localStorage.getItem('auth') ? (
        <>
          <Route path="/mapa">
            <Route path="/mapa/sinistros" component={() => <MapIncidents />} />
            <Route path="/mapa/sinistrosSAMU" component={() => <MapIncidentsSAMU />} />
            <Route path="/mapa/engenharias" component={() => <MapEngineering />} />
            <Route path="/mapa/fiscalizacoes" component={() => <MapSurveillance />} />
            <Route path="/mapa/educacao" component={() => <MapEducation />} />
          </Route>
          <Route path="/minhaconta" component={() => <MyAccount />} />
          <Route path="/alterarsenha" component={() => <UpdatePassword />} />
          <Route path="/painel" component={() => <Dashboard />} />
          <Route path="/importador" component={Importer} />
          <Route path="/duplicidades" component={() => <Duplicities />} />
          <Route path="/imprecisos" component={() => <ReviseLocation />} />

          <Route
            path="/analise/duplicidade/:pathId&:pathIdB/"
            component={() => <AnalyzeDuplicity />}
          />

          <Route path="/revisao" component={Review} />

          <Route path="/registros">
            <Route path="/registros/sinistros/" component={() => <RegistersIncident />} />
            <Route
              path="/registros/sinistrosSAMU/"
              component={() => <RegistersIncidentSAMU />}
            />
            <Route
              path="/registros/engenharias/"
              component={() => <RegistersEngineering />}
            />
            <Route
              path="/registros/fiscalizacoes/"
              component={() => <RegistersSurveillance />}
            />
            <Route path="/registros/educacao/" component={() => <RegistersEducation />} />
            <Route
              path="/registros/duplicidades/:pathId/"
              component={() => <RegistersDuplicidades />}
            />
          </Route>

          <Route path="/registro/">
            <Route
              path="/registro/sinistro/:pathId/"
              component={() => <RegisterIncident />}
            />
            <Route
              path="/registro/sinistroSAMU/:pathId/"
              component={() => <RegisterIncidentSAMU />}
            />
            <Route
              path="/registro/engenharia/:pathId/"
              component={() => <RegisterEngineering />}
            />
            <Route
              path="/registro/fiscalizacao/:pathId/"
              component={() => <RegisterSurveillance />}
            />
            <Route
              path="/registro/educacao/:pathId/"
              component={() => <RegisterEducation />}
            />
          </Route>
          <Route path="/historico/:pathId/" component={() => <History />} />
          <Route path="/add/">
            <Route path="/add/sinistro" component={() => <AddIncident />} />
            <Route path="/add/engenharia" component={() => <AddEngineering />} />
            <Route path="/add/fiscalizacao" component={() => <AddSurveillance />} />
            <Route path="/add/educ" component={() => <AddEducation />} />
          </Route>

          <Route path="/exportador/" component={Export} />
          <Route path="/gerencia/" component={Management} />

          <Route path="/acessarboletim/">
            <Route path="/acessarboletim/access" component={() => <BulletinAcess />} />
            <Route path="/acessarboletim/:pathId" component={() => <BolletinViewer />} />
          </Route>

          <Route path="/editar">
            <Route
              path="/editar/fiscalizacao/:pathId"
              component={() => <UpdateSurveilance />}
            />
            <Route path="/editar/sinistro/:pathId" component={() => <UpdateIncident />} />
            <Route
              path="/editar/sinistroSAMU/:pathId"
              component={() => <UpdateIncidentSAMU />}
            />
            <Route
              path="/editar/engenharia/:pathId"
              component={() => <UpdateEngineering />}
            />
            <Route
              path="/editar/educacao/:pathId"
              component={() => <UpdateEducation />}
            />
            <Route
              path="/editar/duplicidades/:pathId&:pathIdB/"
              component={() => <UpdateDuplicities />}
            />
            <Route path="/editar/impreciso/:pathId" component={() => <UpdateInaccurate />} />
          </Route>
        </>
      ) : (
        history.push('/login')
      )}
    </Switch>
  );
};

export default Routes;
